"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var indexFinder = function indexFinder(compArr, nextAcc) {
  return compArr.length - 1 > nextAcc ? nextAcc : compArr.length - 1;
};
/**
 * `link` and `linkParams` are concatenated for the sake of usability by AEM as of 4-13-22
 */
var SideMenuFactory = function SideMenuFactory(createSideMenu, TitleComponents, LinkComponents, linkClass) {
  var nextAcc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var TitleType = TitleComponents[indexFinder(TitleComponents, nextAcc)];
  var LinkType = LinkComponents[indexFinder(LinkComponents, nextAcc)];
  if (createSideMenu) {
    var target = createSideMenu.newTab ? '_blank' : '_self';
    if (createSideMenu.link) {
      var _title = createSideMenu.title,
        link = createSideMenu.link,
        linkParams = createSideMenu.linkParams;
      var href = "".concat(link).concat(linkParams || '');
      if (createSideMenu.next) {
        var next = createSideMenu.next;
        if (Array.isArray(next)) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LinkType, {
              href: href,
              target: target,
              className: linkClass,
              children: _title
            }), next.map(function (child, index) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
                children: SideMenuFactory(child, TitleComponents, LinkComponents, linkClass, nextAcc + 1)
              }, index + Math.random());
            })]
          });
        }
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LinkType, {
            href: href,
            target: target,
            className: linkClass,
            children: _title
          }), SideMenuFactory(next, TitleType, LinkType, linkClass, nextAcc + 1)]
        });
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(LinkType, {
        href: href,
        target: target,
        className: linkClass,
        children: _title
      });
    }
    if (createSideMenu.next) {
      var _title2 = createSideMenu.title,
        _next = createSideMenu.next;
      if (Array.isArray(_next)) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TitleType, {
            children: _title2
          }), _next.map(function (child, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
              children: SideMenuFactory(child, TitleComponents, LinkComponents, linkClass, nextAcc + 1)
            }, index + Math.random());
          })]
        });
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TitleType, {
          children: _title2
        }), SideMenuFactory(_next, TitleComponents, LinkComponents, linkClass, nextAcc + 1)]
      });
    }
    var title = createSideMenu.title;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(TitleType, {
      children: title
    });
  } else {
    console.error('There is no data being passed in.');
  }
};
var _default = SideMenuFactory;
exports["default"] = _default;